import React from "react"
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Trans} from "@lingui/macro";
import {UseFormReturn} from "react-hook-form";

interface SbFormDialogProps extends UseFormReturn {
    onClose: () => void
    width:  'xs' | 'sm' | 'md' | 'lg' | 'xl'
    titleText: string
    height?: string
    contentText?: string
    children?: any
    submitButton: boolean
    closeButton?: boolean
    onSubmit: () => void
    validationError: (values: any) => void
    schema?: any
}

interface SbFormDialogState {

}

export class SbFormDialog extends React.Component<SbFormDialogProps, SbFormDialogState>
{
    render () {
        return (
            <Dialog open={true} onClose={this.props.onClose} maxWidth={this.props.width} fullWidth>
                <DialogTitle>
                    {this.props.titleText}
                </DialogTitle>
                <form onSubmit={this.props.handleSubmit(this.props.onSubmit, this.props.validationError)}>
                    {
                        this.props.height ?
                            <DialogContent sx={{height: this.props.height}}>
                                {this.props.contentText}
                                {this.props.children}
                            </DialogContent>
                            :
                            <DialogContent>
                                {this.props.contentText}
                                {this.props.children}
                            </DialogContent>
                    }
                    <DialogActions>
                        {
                            this.props.closeButton &&
                            <Button onClick={this.props.onClose}
                                    variant={"contained"}
                                    color="neutral"
                                    sx={{
                                        textTransform: "none",
                                        mr: 1,
                                        width: 100
                                    }}
                                    disableElevation>
                                <Trans id={"sb-dialog.close"}>
                                    Chiudi
                                </Trans>
                            </Button>
                        }
                        {
                            this.props.submitButton &&
                            <Button variant="contained"
                                    type="submit"
                                    sx={{
                                        backgroundColor: 'secondary.main',
                                        color: 'white',
                                        mr: 1,
                                        textTransform: "none",
                                        width: 100
                                    }}
                            >
                                <Trans id={"sb-dialog.save"}>
                                    Salva
                                </Trans>
                            </Button>
                        }
                    </DialogActions>
                </form>
            </Dialog>
        )
    }
}
